A URL of an external apply form.

This is used only when the hirer selected linkout on the draft and is ignored for SOA.

When posting with linkout, this value takes precedence over the draft URL; if omitted, the draft URL is used, and the request fails if neither is present.

When updating with linkout, this value takes precedence over the draft URL; if omitted, the draft URL is used, then the live job ad URL, and the request fails if none is present.

This requires that the hirer has an `HiringOrganizationApiCapabilities.applicationMethodCodes` that includes `ApplicationUri`.

This field has a maximum length of 500 characters.
